import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../../../firebase";

// The hot-reloadable ranking/search config lives in a single Firestore doc:
// config/feedRanking (see functions/search/getRankingConfig.js).
const CONFIG_COLLECTION = "config";
const CONFIG_DOC = "feedRanking";

// Mirrors DEFAULT_CONFIG in functions/search/getRankingConfig.js so the admin
// UI has sensible values to show/seed if a field (or the whole doc) is missing.
export const DEFAULT_FEED_CONFIG = {
  useInternalFeed: false,
  useInternalSearch: false,
  lambdaDecayPerDay: 0.03,
  candidatePoolCap: 500,
  weights: {
    recency: 1.0,
    popularity: 1.0,
    engagement: 1.0,
    affinity: 1.0,
    orgPriority: 0.5,
    qtPriority: 0.5,
    nearby: 0.5,
  },
  popSubWeights: { like: 1, save: 2, reaction: 1, share: 3, listen: 1 },
  search: {
    fieldWeights: { title: 5, narrator: 3, creator: 3, org: 3, description: 1 },
    typeaheadLimit: 8,
    fullLimit: 30,
  },
};

export const getFeedRankingConfig = async () => {
  try {
    const docRef = doc(db, CONFIG_COLLECTION, CONFIG_DOC);
    const snap = await getDoc(docRef);
    const data = snap.exists() ? snap.data() : {};
    // Merge over defaults so every field is present for the UI.
    return {
      ...DEFAULT_FEED_CONFIG,
      ...data,
      weights: { ...DEFAULT_FEED_CONFIG.weights, ...(data.weights || {}) },
      popSubWeights: {
        ...DEFAULT_FEED_CONFIG.popSubWeights,
        ...(data.popSubWeights || {}),
      },
      search: {
        ...DEFAULT_FEED_CONFIG.search,
        ...(data.search || {}),
        fieldWeights: {
          ...DEFAULT_FEED_CONFIG.search.fieldWeights,
          ...((data.search || {}).fieldWeights || {}),
        },
      },
    };
  } catch (error) {
    console.log("Error fetching feedRanking config:", error.message);
    return { ...DEFAULT_FEED_CONFIG };
  }
};

// Writes the config with merge so it creates the doc if missing and never
// clobbers unrelated fields.
export const updateFeedRankingConfig = async (docData) => {
  const docRef = doc(db, CONFIG_COLLECTION, CONFIG_DOC);
  return await setDoc(docRef, docData, { merge: true });
};
